import { useAtom } from 'jotai'
import { apuracaoAtom } from '@/features/products/state/selectApuracao'

export function useApuracaoSelecionada() {
  const [apuracaoSelecionada, setApuracaoSelecionada] = useAtom(apuracaoAtom)
  return { apuracaoSelecionada, setApuracaoSelecionada }
}
